const { h, render, Component } = require('preact');
const ArticlesList = require('./articles_list')

class ContextualArticlesResults extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.results && this.props.results.contents){
            let articles = [];
            if (this.props.results.contents.length > 0){
                articles = this.props.results.contents;
            }
            return (
                <div class="search-results-section topics-related-article">
                    <h3>
                        {I18n.translate("js.modules.web_2018.topics_related_to_order")}
                    </h3>
                    <ArticlesList
                        articles={articles}
                        handleNeedHelpFromSearchResults = {this.props.handleNeedHelpFromSearchResults}
                        additionalProperties = {"top-margin-articles"}

                    />
                </div>
            )
        }
        return null;
    }
}
module.exports = ContextualArticlesResults